import { combineReducers } from 'redux';
import auth from './auth';
import profile from './profile';
import loading from './loading';
import inspection from './inspection';
import startInspection from './start-inspection';
import questions from './questions';

export default combineReducers({
  auth,
  profile,
  loading,
  inspection,
  startInspection,
  questions
});
